import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'document-type-selection-dialog',
  template: `
    <h2 mat-dialog-title>Select Document Type</h2>
    <mat-dialog-content class="document-type-dialog-content">
      <mat-form-field class="document-type-form-field" appearance="outline">
        <mat-label>Document Type</mat-label>
        <mat-select [(value)]="selectedDocumentType">
          <mat-option *ngFor="let type of documentTypes" [value]="type">
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onConfirm()">Upload</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .document-type-dialog-content {
      padding: 20px;
      min-width: 300px;
    }
    .document-type-form-field {
      width: 100%;
      margin-bottom: 20px;
    }
    mat-dialog-actions {
      padding-right: 24px;
      padding-bottom: 12px;
    }
    mat-dialog-title {
      padding: 16px;
      font-size: 1.5rem;
      font-weight: bold;
    }
  `]
})
export class DocumentTypeSelectionDialog {
  documentTypes: Array<{ value: number, name: string }> = [
    { value: 2, name: 'Bill of Lading or Manifest' },
    { value: 5, name: 'Carrier Confirmation' },
    { value: 6, name: 'Carrier Invoice' },
    { value: 8, name: 'Damage Claims' },
    { value: 18, name: 'Credit Card Receipt' },
    { value: 7, name: 'Customs Document' },
    { value: 3, name: 'Delivery Receipt (if addition to PoD)' },
    { value: 14, name: 'Email' },
    { value: 15, name: 'Lumper Receipt' },
    { value: 16, name: 'Marshalling' },
    { value: 9, name: 'Other Documents (Bond Receipt)' },
    { value: 10, name: 'Packing Slip' },
    { value: 17, name: 'Photos' },
    { value: 11, name: 'Pickup' },
    { value: 1, name: 'POD - Proof Of Delivery' },
    { value: 12, name: 'Scale Ticket' },
    { value: 4, name: 'Walk The Path - Delivery / Installation Document' },
    { value: 13, name: 'Weight Inspection Certificate' },
    { value: 51, name: 'Company Information' },
    { value: 52, name: 'Credit Application' },
    { value: 53, name: 'Credit Reference' },
    { value: 54, name: 'Other Documentation' },
    { value: 19, name: 'Carrier Company Letterhead' },
    { value: 21, name: 'Assignment Letter Carrier' },
    { value: 22, name: 'Assignment-Letter Factoring Company' },
    { value: 23, name: 'Assignment-Release Letter Factoring Company' },
    { value: 24, name: 'Assignment-Release Letter Carrier' },
    { value: 20, name: 'VOID Cheque' },
    { value: 25, name: 'Authorities - Provincial MOT (CVOR)' },
    { value: 26, name: 'Authorities - State DOT' },
    { value: 27, name: 'Authorities - US DOT' },
    { value: 28, name: 'Certificate of Insurance - Cargo (if all policies same file here)' },
    { value: 29, name: 'Certificate of Insurance - General Liability (BIPD)' },
    { value: 30, name: 'Certificate of Insurance - Auto/Asset (BIPD Express)' },
    { value: 31, name: 'Certificate of Insurance - Surety Bond/ Trust' },
    { value: 32, name: 'Certificate of Insurance - Other Coverage' },
    { value: 33, name: 'Certificate of Insurance - With "FBI" Named Party' },
    { value: 34, name: 'Hazardous Material Certificate' },
    { value: 35, name: 'W8/W9' },
    { value: 36, name: 'Workers Compensation - General Certificate' },
    { value: 37, name: 'Workers Compensation - With "FBI" Named Holder Party' },
    { value: 38, name: 'Other Safety Certificate' },
    { value: 51, name: 'Certificate of Insurance - Asset (Trailer)' },
    { value: 52, name: 'Trailer Ownership Certificate' },
    { value: 53, name: 'Trailer Build Photos' },
    { value: 54, name: 'Plate' },
    { value: 55, name: 'Trailer Repair Report/Invoice' },
    { value: 56, name: 'Trailer Bill of Sale' },
    { value: 57, name: 'Trailer Inspection Reports (Manual)' },
    { value: 39, name: 'Passports' },
    { value: 40, name: 'Form 3299 – Declaration for Free Entry' },
    { value: 41, name: 'Power of Attorney' },
    { value: 42, name: 'Supplemental Declaration' },
    { value: 43, name: 'Inventory Listing of Household Goods' },
    { value: 44, name: 'I-94 Card for Each Traveller' },
    { value: 45, name: 'Scale Tickets on Full Loads' },
    { value: 46, name: 'Passports' },
    { value: 47, name: 'Work Permit or Visa' },
    { value: 48, name: 'Inventory Listing of Household Goods' },
    { value: 49, name: 'New Canadian Address' },
    { value: 50, name: 'Scale Tickets on Full Loads' }
  ];

  selectedDocumentType: { value: number, name: string } | undefined;

  constructor(
    public dialogRef: MatDialogRef<DocumentTypeSelectionDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.selectedDocumentType) {
      this.dialogRef.close(this.selectedDocumentType); // Send back the selected document
    }
  }
}